import { FunctionComponent, useContext, useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import NewstickerPost from './NewstickerPost'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import translate from '@i18n'
import { ProcessedPost } from '@hooks/useNewstickerScribblePolling'

const { TOITeaserNewstickerContext } = contextToiTeaser

const StyledNewstickerVertical = styled.div`
  ${() => css`
    ${desktopCSS(css`
      display: none;
    `)}

    ${tabletCSS(css`
      display: none;
    `)}

    ${mobileCSS(css`
      width: 100%;
    `)}
  `};
`

const createPlaceholderItem = (id: number) => ({
  id,
  dateInfo: {
    date: '',
    time: '',
    dateOrTime: '',
    sameDateTime: '',
  },
  text: translate('scribble.loadingEntry'),
})

const NewstickerVertical: FunctionComponent = () => {
  const [posts, setPosts] = useState<ProcessedPost[]>([
    createPlaceholderItem(1),
    createPlaceholderItem(2),
    createPlaceholderItem(3),
  ])

  const { posts: newsTickerPosts } = useContext(TOITeaserNewstickerContext)

  useEffect(() => {
    if (newsTickerPosts.length > 0) {
      setPosts(newsTickerPosts)
    }
  }, [newsTickerPosts])

  return (
    <StyledNewstickerVertical>
      {posts.map(({ id, dateInfo, text }, index) => (
        <NewstickerPost key={id} dateInfo={dateInfo} isFirstChild={index === 0}>
          {text}
        </NewstickerPost>
      ))}
    </StyledNewstickerVertical>
  )
}

export default NewstickerVertical
